import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { resetStorageIfCompanyChanged } from "./config/company";
import { applyTheme } from "./config/theme";
import { applyBranding, getCachedBranding } from "./lib/branding";
import { unregisterServiceWorkers } from "./lib/serviceWorkerCleanup";

// Remove service worker antigo (PWA legado) que servia o layout velho do cache
unregisterServiceWorkers();

// Antes de montar: descarta carrinho/token/pedido salvos se forem de outra empresa
resetStorageIfCompanyChanged();

// Aplica as cores da loja (REACT_APP_COLOR_*) antes do primeiro render
applyTheme();

// Favicon/título da última visita até GET /companies responder (useCompanyBranding)
applyBranding(getCachedBranding() || {});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
